import { render } from "./ShiftsSchemaManage.vue?vue&type=template&id=36db9fbe"
import script from "./ShiftsSchemaManage.vue?vue&type=script&lang=js"
export * from "./ShiftsSchemaManage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__